module.exports = __webpack_public_path__ + "static/media/back-button.d91a14f6.svg";